import { render } from "./DealInfoModal.vue?vue&type=template&id=265b680a&scoped=true&ts=true"
import script from "./DealInfoModal.vue?vue&type=script&lang=ts"
export * from "./DealInfoModal.vue?vue&type=script&lang=ts"

import "./DealInfoModal.vue?vue&type=style&index=0&id=265b680a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265b680a"]])

export default __exports__